const plugin = require('tailwindcss/plugin');

/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    './pages/**/*.{js,ts,jsx,tsx,mdx}',
    './components/**/*.{js,ts,jsx,tsx,mdx}',
    './app/**/*.{js,ts,jsx,tsx,mdx}',
  ],
  theme: {
    extend: {
      fontFamily: {
        inter: ['var(--font-inter)'],
        roboto: ['var(--font-roboto)'],
        opensans: ['var(--font-opensans)'],
        lora: ['var(--font-lora)'],
        poppins: ['var(--font-poppins)'],
        playfair: ['var(--font-playfair)'],
        montserrat: ['var(--font-montserrat)'],
      },
      backgroundImage: {
        'gradient-radial': 'radial-gradient(var(--tw-gradient-stops))',
        'gradient-conic':
          'conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))',
      },
      colors: {
        // 'maincolor': '#1b2f6b',
        'maincolor': 'var(--maincolor)',
        'maincolortrans': '#2331424d',
        // 'secondary': '#015B97',
        // 'secondary': '#05294d',
        'secondary': 'var(--secondarycolor)',
        // 'third': '#941109',
        'third': 'var(--thirdcolor)',
        // 'price': '#941109',
        'price': 'var(--pricecolor)',
        'forth': 'var(--fourthcolor)',
        'light': 'white',
        'navlight': '#D3D3D3',
        'mainhover': 'gray',
        'layover': 'var(--layovercolor)',
        'content': 'var(--textcolor)',
        'label': 'var(--labelcolor)',
        'labelhighlight': 'var(--labelhighlightcolor)',
        'icon': 'var(--iconcolor)',

      },
      backgroundColor: ['hover'],
    },
  },
  plugins: [
    plugin(function ({ addComponents, theme }) {
      addComponents({
        '.card-unliked': {
          position: 'absolute',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          top: '0.25rem', // top-1
          right: '0.25rem', // right-1
          zIndex: '40',
          height: '2rem', // h-8
          width: '2rem', // w-8
          justifyContent: 'center',
          alignItems: 'center',
          borderWidth: '1px',
          borderColor: theme('colors.secondary'),
          borderRadius: '0.375rem', // rounded-md
          padding: '0.25rem', // p-1
        },
        '.card-liked': {
          position: 'absolute',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          top: theme('spacing.1'),
          right: theme('spacing.1'),
          zIndex: 40,
          height: theme('spacing.8'),
          width: theme('spacing.8'),
          justifyContent: 'center',
          alignItems: 'center',
          borderWidth: '1px',
          borderColor: theme('colors.third'),
          borderRadius: theme('borderRadius.md'),
          padding: theme('spacing.1'),
        },
        '.label': {
          position: 'absolute',
          top: theme('spacing.2'),
          backgroundColor: theme('colors.label'),
          color: theme('colors.light'),
          padding: theme('spacing.1'),
          borderTopRightRadius: theme('borderRadius.md'),
          borderBottomRightRadius: theme('borderRadius.md'),
          zIndex: 10,
          // fontWeight: theme('fontWeight.semibold'),
        },
        '.label-highlight': {
          position: 'absolute',
          top: theme('spacing.2'),
          backgroundColor: theme('colors.labelhighlight'),
          color: theme('colors.light'),
          padding: theme('spacing.1'),
          borderTopRightRadius: theme('borderRadius.md'),
          borderBottomRightRadius: theme('borderRadius.md'),
          zIndex: 10,
          // fontWeight: theme('fontWeight.semibold'),
        },
        '.transport-label-container': {
          position: 'absolute',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          bottom: '0',
          left: '0',
        },
        '.transport-label': {
          color: theme('colors.light'),
          borderRadius: theme('borderRadius.sm'),
          fontSize: theme('fontSize.sm'),
          paddingLeft: theme('spacing.1'),
          paddingRight: theme('spacing.1'),
          marginLeft: theme('spacing.1'),
          marginBottom: theme('spacing.1'),
        },
        '.large-card-image': {
          '@screen sm': {
            width: '300px',
          },
          width: '100%',
          objectFit: 'cover',
          aspectRatio: '4 / 3',
          borderRadius: theme('borderRadius.md'),
          overflow: 'hidden',
        },
        '.image-container': {
          position: 'relative',
          width: '250px',
          height: '187.5px',
          borderRadius: theme('borderRadius.md'),
          overflow: 'hidden',
        },
        '.form-label': {
          fontSize: theme('fontSize.sm'),
        },
        '.btn': {
          width: '100%',
          borderRadius: theme('borderRadius.md'),
          padding: theme('spacing.2'),
          color: theme('colors.light'),
          fontWeight: theme('fontWeight.bold'),
        },
        '.submit-btn': {
          color: theme('colors.light'),
          backgroundColor: theme('colors.maincolor'),
        },
        '.round-style': {
          borderRadius: theme('borderRadius.lg'),
        },

      });
    }),
  ],
}